//Styles
import Styles from "./styles.module.scss";
import { useQuery } from "hooks/query";
import localPrivacyPolicy from "../../documents/privacy_policy.pdf";

const PrivacyPolicy = () => {
  const { data, loading } = useQuery({
    url: "/api/legal/documents/current/",
  });
  const document = data?.find((doc) => doc.document_type === "privacy_policy");
  // Fall back to the bundled PDF when the API fails or has no current document
  const source = document?.file || (loading ? null : localPrivacyPolicy);

  return (
    <section className={Styles.wrapper}>
      <h3 style={{ marginBlock: "20px" }}>Privacy Policy</h3>
      {source && (
        <iframe
          title="privacy-policy"
          src={`${source}#toolbar=0&navpanes=0`}
          height={"100%"}
          width={"100%"}
        />
      )}
    </section>
  );
};

export default PrivacyPolicy;
